/**
 * @deprecated Use date from '@e3dc-react/shell/Libs/date' instead.
 */
import moment, { Moment } from 'moment'

import 'moment/locale/en-gb'
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/nl'
import 'moment/locale/it'
import 'moment/locale/pl'
import 'moment/locale/pt'
import 'moment/locale/es'
import 'moment/locale/sv'
import 'moment/locale/fr-ch'
import 'moment/locale/de-ch'

/**
 * @deprecated Use date from '@e3dc-react/shell/Libs/date' instead.
 */
export type DeprecatedMoment = Moment

/**
 * @deprecated Use date from '@e3dc-react/shell/Libs/date' instead.
 */
export type { DeprecatedMoment as Moment }

/**
 * @deprecated Use date from '@e3dc-react/shell/Libs/date' instead.
 */
export default moment
